import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteUser } from '../../services/UsersService';
import { User, DeleteUserRequest } from '../../types/Users';

type Result = UseMutationResult<User, Error, DeleteUserRequest>;

function useDeleteUser(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteUser, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['users'] });
      queryClient.invalidateQueries({ queryKey: ['users-lazy'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteUser;
